const layoutProps = reactive({
	title: '',
});

export function useLayout() {
	return layoutProps;
}
